import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  controlRow: {
    display: "flex",
    alignItems: "center",
  },
  label: {
    marginRight: "0.5rem",
  },
  dropdown: {
    border: "1px solid grey",
    borderRadius: "0.5rem",
    padding: "0.5rem 0.75rem",
  },
  selectedTypes: {
    display: "flex",
    gap: "0.5rem",
    flexWrap: "wrap",
  },
  infoText: {
    opacity: 0.35,
  },
  warningText: {
    marginTop: "1rem",
    color: theme.palette.warning.main,
  },
}));

export default useStyles;
